<template>
  <b-container fluid class="hero">
    <b-row>
      <b-col md="8" offset-md="1">
        <h1 v-html="headline"></h1>
        <p>{{ lead }}</p>
      </b-col>
    </b-row>
    <div class="image-wrap">
      <img :src="'./assets/' + image">
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'hero',
  props: ['headline', 'lead', 'image']
}
</script>

<style lang="scss">
.hero {
  @include sans-font(normal);
  position: relative;
  padding: 10em 0 2em;
  margin-bottom: 3em;
  display: flex;
  z-index: 0;
  overflow: hidden;
  @media all and (max-width: $screen-md) {
    flex-direction: column;
    position: static;
    margin-bottom: 0;
    padding-top: 4em;
  }
  .row {
    @media all and (max-width: $screen-md - 1) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-image: repeating-linear-gradient(
      90deg,
      $white,
      $white 50%,
      rgba($white, 0) 100% /* determines size */
    );
    @media all and (max-width: $screen-md) {
      background-image: none;
    }
    z-index: 0;
  }
  > .image-wrap {
    img {
      position: absolute;
      object-fit: cover;
      // left: 0;
      right: -400px;
      top: 0;
      z-index: -1;
      height: 100%;
      @media all and (max-width: $screen-md) {
        position: relative;
        // left: -15px;
        // width: calc(100% + 30px);
        width: calc(140% + 30px);
        right: 150px;
      }
      @media all and (max-width: 370px) {
        right: 100px;
      }
    }
    @media all and (max-width: $screen-md) {
      position: relative;
      top: -15px;
      z-index: -1;
      &:before {
        content: "";
        width: calc(100% + 30px);
        height: 100%;
        top: -20px;
        left: -15px;
        position: absolute;
        background-image: repeating-linear-gradient(
          180deg,
          $white,
          $white 10%,
          rgba($white, 0) 100% /* determines size */
        );
        z-index: 0;
      }
    }
  }
  h1 {
    @include serif-font();
    font-size: 105px;
    line-height: 1;
    color: $black;
    margin-bottom: .5em;
    margin-top: .5em;
    @media all and (max-width: $screen-md) {
      font-size: 60px;
    }
    @media all and (max-width: 370px) {
      font-size: 50px;
    }
    span {
      position: relative;
      z-index: 0;
      display: inline-block;
      // padding-right: 30px;
      &:before {
        position: absolute;
        content: "";
        line-height: 1;
        background-color: $blue;
        z-index: -1;
        height: 75%;
        left: 0;
        top: 25%;
        width: 110%;
      }
    }
  }
  p {
    font-size: 30px;
    line-height: 1.4;
    @media all and (max-width: $screen-md) {
      font-size: 23px;
    }
  }
}
</style>
